import { render, staticRenderFns } from "./JobEconomicPrevisionTable.vue?vue&type=template&id=edb6798c&scoped=true&"
import script from "./JobEconomicPrevisionTable.vue?vue&type=script&lang=js&"
export * from "./JobEconomicPrevisionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6798c",
  null
  
)

export default component.exports